import React from 'react';
import { Lock, Unlock } from 'lucide-react';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';
import RichTextEditor from './RichTextEditor';

export const SharedFieldRow = ({ field, label, job, shared, onChange }) => {
  const unlocked = (job.unlocked_fields || []).includes(field);
  const toggle = (locked) => {
    const rest = (job.unlocked_fields || []).filter(f => f !== field);
    onChange({ ...job, unlocked_fields: locked ? rest : [...rest, field], [field]: locked ? job[field] : (job[field] || shared?.[field] || '') });
  };
  return (
    <div data-testid={`job-shared-${field}`}>
      <div className="flex items-center justify-between mb-1.5">
        <Label className="text-slate-300 text-xs">{label}</Label>
        <label className="flex items-center gap-2 text-xs text-slate-400 cursor-pointer">
          {unlocked ? <Unlock className="w-3.5 h-3.5 text-amber-400" /> : <Lock className="w-3.5 h-3.5 text-cyan-400" />}
          {unlocked ? 'Custom for this job' : 'Locked to shared text'}
          <Switch data-testid={`job-shared-${field}-lock-switch`} checked={!unlocked} onCheckedChange={toggle} />
        </label>
      </div>
      {unlocked ? (
        <RichTextEditor testId={`job-${field}`} value={job[field]} onChange={v => onChange({ ...job, [field]: v })} minHeight={80} />
      ) : (
        <div data-testid={`job-shared-${field}-preview`} className="rounded-md border border-dashed border-slate-700 bg-[#080d18]/60 px-3 py-2 text-sm text-slate-400">
          {shared?.[field]
            ? <div className="rich-content" dangerouslySetInnerHTML={{ __html: shared[field] }} />
            : <span className="italic text-slate-500">Empty. Hidden on the post. Add text in Settings, Shared Job Post Sections.</span>}
        </div>
      )}
    </div>
  );
};

export default SharedFieldRow;
